import { UserMini } from "@infoland/iprova-api";
import { DocumentReviewState } from "@/enums";
export interface DocumentReviewer {
    user: UserMini;
    order: number;
    round: DocumentReviewRound;
    active: boolean;
    reviewed_on_date_time: string;
    deadline_days: number;
    deadline_date: string;
    state: DocumentReviewState;
    reject_comment: string;
    escalated: boolean;
}

export interface DocumentReviewRound {
    round_id: number;
    review_template_round_id: number;
    name: string;
    order: number;
    active: boolean;
    password_required: boolean;
    type: ReviewRoundType;
    start_date_time: string;
    end_date_time: string;
    instruction: string;
    show_instruction_for_current_user: boolean;
}

export enum ReviewRoundType {
    single_reviewer = "single_reviewer",
    serial_reviewers = "serial_reviewers",
    parallel_reviewers = "parallel_reviewers"
}
